import CopySitesMap from './CopySitesMap'

export default CopySitesMap
